import { _WMSLayer as WMSLayer } from '@deck.gl/geo-layers';
import type { WMSLayerProps } from '@deck.gl/geo-layers';
import { parse } from '@loaders.gl/core';
import type { ImageSource } from '@loaders.gl/wms';

const EXPORT_URL =
  'https://ags.cuzk.gov.cz/arcgis/rest/services/GEONAMES/Geonames/MapServer/export';

class CuzkGeonamesWMSLayer extends WMSLayer {
  static layerName = 'CuzkGeonamesWMSLayer';

  _createImageSource(props: WMSLayerProps): ImageSource {
    const exportUrl = props.data as string;
    return {
      getMetadata: async () => ({}),
      getImage: async ({ width, height, boundingBox, layers }) => {
        const [[west, south], [east, north]] = boundingBox;
        const params = new URLSearchParams({
          f: 'image',
          bbox: `${west},${south},${east},${north}`,
          bboxSR: '4326',
          imageSR: '4326',
          size: `${width},${height}`,
          format: 'png32',
          transparent: 'true',
          adjustAspectRatio: 'false',
          layers: layers.join(','),
        });
        const response = await fetch(`${exportUrl}?${params}`);
        return parse(response);
      },
    } as unknown as ImageSource;
  }
}

export const cuzkGeonamesWmsLayer = () =>
  new CuzkGeonamesWMSLayer({
    id: 'cuzk-geonames-wms-layer',
    data: EXPORT_URL,
    serviceType: 'wms',
    layers: ['show:0'],
    srs: 'EPSG:4326',
  });
